import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { translate } from 'services/i18nService';
import ModalService from 'services/ModalService';
import FanClubStore from 'stores/FanClubStore';
import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';
import Button from 'components/Button/Button';
import { CONTEXTUAL_GOLD_MODAL_AREAS } from 'utils/consts';

import lockedImg from '../../../images/locked.png';

import styles from './PrivateChatBasicAnnouncement.css';


const PrivateChatBasicAnnouncement = (props) => {
  const { user, toggleRegisterGoldOverlay } = props;
  const { showRegistrationModal, performerDetails } = ProfileStore;
  const { isFanClubActive } = FanClubStore;
  const { isGuestBilling } = UserStore;

  const handleGuestOpenGoldOverlay = useCallback(() => {
    ModalService.hideModal();
    toggleRegisterGoldOverlay(true);
  }, [toggleRegisterGoldOverlay]);

  const handleInTranslationClick = useCallback(() => {
    if (isFanClubActive && user.username && !isGuestBilling) {
      ModalService.showModal(ModalService.MODAL_KEYS.JOIN_FAN_CLUB_MODAL);
    } else if (isGuestBilling) {
      ModalService.showModal(ModalService.MODAL_KEYS.GUEST_BILLING_MODAL, {
        close: () => ModalService.hideModal(),
        show: true,
      });
    } else if (user.username) {
      ModalService.showModal(
        ModalService.MODAL_KEYS.UPGRADE_TO_GOLD_MODAL,
        { area: CONTEXTUAL_GOLD_MODAL_AREAS.PRIVATE_MESSAGING }
      );
    } else {
      const modalProps = {
        area: CONTEXTUAL_GOLD_MODAL_AREAS.PRIVATE_MESSAGING,
        onMembershipClick: handleGuestOpenGoldOverlay,
      };

      ModalService.showModal(
        ModalService.MODAL_KEYS.UPGRADE_TO_GOLD_MODAL,
        modalProps
      );
    }
  }, [
    isFanClubActive,
    isGuestBilling,
    user,
    handleGuestOpenGoldOverlay,
  ]);

  useEffect(() => {
    const toggleModalInTranslate = document.querySelector('#toggleModalInTranslate');
    if (toggleModalInTranslate) {
      toggleModalInTranslate.addEventListener('click', handleInTranslationClick);
    }

    return () => {
      if (toggleModalInTranslate) {
        toggleModalInTranslate.removeEventListener('click', handleInTranslationClick);
      }
    };
  }, [handleInTranslationClick, user.username]);

  const handleUpgrade = useCallback(() => {
    if (user.username && !isGuestBilling) {
      ModalService.showModal(
        ModalService.MODAL_KEYS.UPGRADE_TO_GOLD_MODAL,
        { area: CONTEXTUAL_GOLD_MODAL_AREAS.PRIVATE_MESSAGING }
      );
    } else if (isGuestBilling) {
      const modalProps = {
        area: CONTEXTUAL_GOLD_MODAL_AREAS.PRIVATE_MESSAGING,
        onMembershipClick: handleGuestOpenGoldOverlay,
      };

      ModalService.showModal(
        ModalService.MODAL_KEYS.UPGRADE_TO_GOLD_MODAL,
        modalProps
      );
    } else {
      showRegistrationModal();
    }
  }, [
    handleGuestOpenGoldOverlay,
    isGuestBilling,
    showRegistrationModal,
    user.username,
  ]);

  const handleMessage = () => {
    const { isBasicUser } = UserStore;
    if (user.username || isGuestBilling) {
      if (isFanClubActive) {
        if (isBasicUser) {
          return translate('v2profile.basic.user.notif.with.fanclub', {
            0: `<span class=${styles.link} id='toggleModalInTranslate'>`,
            1: '</span>',
          });
        }

        return translate('v2profile.private.notif.with.fan.club', {
          0: performerDetails.username,
          1: `<span class=${styles.link} id='toggleModalInTranslate'>`,
          2: '</span>',
        });

      }
      if (isBasicUser) {
        return translate('v2profile.basic.user.notif.without.fanclub', {
          0: `<span class=${styles.link} id='toggleModalInTranslate'>`,
          1: '</span>',
        });
      }

      return translate('v2profile.private.notif.without.fan.club', { 0: performerDetails.username });
    }

    if (isFanClubActive) {
      return translate('v2profile.private.guest.notif.with.fan.club', {
        0: `<span class=${styles.link} id='toggleModalInTranslate'>`,
        1: '</span>',
        2: performerDetails.username,
      });
    }

    return translate('v2profile.private.guest.notif.without.fan.club', {
      0: `<span class=${styles.link} id='toggleModalInTranslate'>`,
      1: '</span>',
      2: performerDetails.username,
    });
  };

  return (
    <div className={styles.announcementWrapper}>
      <img alt="locked" src={lockedImg} />
      <p>{handleMessage()}</p>
      <Button
        colour="green"
        label={user.username ? translate('epay.epay.upgrade.now') : translate('strings.LoginView.create')}
        onClick={handleUpgrade}
      />
    </div>
  );
};

PrivateChatBasicAnnouncement.propTypes = {
  toggleRegisterGoldOverlay: PropTypes.func,
  user: PropTypes.object,
};

PrivateChatBasicAnnouncement.defaultProps = {
  toggleRegisterGoldOverlay: () => undefined,
  user: undefined,
};

export default observer(PrivateChatBasicAnnouncement);
